import { VectorState } from '../utils/VectorState.js';
import { GeometryUtils as G } from '../utils/Geometry.js';
export { ChannelPathArc };
class ChannelPathArc {
    constructor({ startPoint, startDirection, endPoint, endDirection, center, radius, rotation, length }) {
        this.startPoint = startPoint;
        this.startDirection = startDirection;
        this.endPoint = endPoint;
        this.endDirection = endDirection;
        this.center = center;
        this.radius = radius;
        this.rotation = rotation;
        this.length = length !== null && length !== void 0 ? length : this.computeLength();
    }
    /**
     * Note: flags are defined incorrectly to accomodate the inverted coordinate system of svgs
     */
    largeArcFlag() {
        const s = VectorState.of(this.startDirection, this.endDirection);
        return this.sweepFlag() ? s.isRight() : s.isLeft();
    }
    sweepFlag() {
        return this.rotation > 0;
    }
    pathString() {
        return `A ${this.radius} ${this.radius} 0 ${this.largeArcFlag() ? 1 : 0} ${this.sweepFlag() ? 1 : 0} ${this.endPoint[0]} ${this.endPoint[1]}`;
    }
    computeLength() {
        return G.arcLength(this.startPoint, this.endPoint, this.center, this.radius, this.rotation);
    }
}
//# sourceMappingURL=ChannelPathArc.js.map